import { ComponentOptions } from "../../../framework/components/components/component";
import { TemplateComponent } from "../../../framework/components/components/templateComponent";
import K_LoginBanner from "../templates/K_LoginBanner";

export interface LoginBannerOptions extends ComponentOptions {
    src?: string;
    bsc?: string;
}

export class LoginBanner extends TemplateComponent {

    options: LoginBannerOptions;

    constructor(options: LoginBannerOptions) {
        super(K_LoginBanner, options);
    }

    preRender() {
        const options = this.options;

        options.src = options.src || "";
    }

    create() {
        $(window).bind("resize", this.resizeWindow);
        this.resizeWindow();
    }

    /*
    * ResizeWindow
    * This function will make sure everything is acceptable after a resize of the window
    *
    */
    resizeWindow() {
        var windowElem = $(window);

        $("#LoginBanner").css({
            width: windowElem.width() > 996 ? windowElem.width() : 996
        });
    }

}
